import React, { useEffect, useState } from "react";
import Header from "./Header";
import { AiFillCheckCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

import { apiURL } from "../../api/index";

function Bookings(props) {
  const Navigate = useNavigate();
  const adminDetails = JSON.parse(localStorage.getItem("adminDetails"));

  const [message, setMessage] = useState("");

  const handleCheck = async (bookingId) => {
    try {
      const res = await fetch(`${apiURL}/adminbookings/${bookingId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status: "Completed" }),
      });

      if (res.status === 200) {
        setMessage(
          "Congragulations! The Hiring Has Been Successfully Completed"
        );
        setTimeout(() => {
          setMessage("");
        }, 2000);
      }
    } catch (error) {
      setMessage(
        "Sorry! Something Unexpected Occurred, Please Contact Your Customer"
      );
      setTimeout(() => {
        setMessage("");
      }, 2000);
    }
  };

  useEffect(() => {
    const BookingsPageLoaded = async () => {
      try {
        if (adminDetails.email === "" || adminDetails.password === "") {
          Navigate("/admin");
        } else {
          const res = await fetch(
            `${apiURL}/adminbookings/${adminDetails.email}/${adminDetails.password}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          await res.json();
        }
      } catch (error) {
        Navigate("/admin");
      }
    };
    BookingsPageLoaded();
  }, [Navigate, adminDetails.email, adminDetails.password]);

  return (
    <>
      {message && (
        <div className="bg-green-600 text-white p-2 w-full text-center font-semibold absolute">
          {message}
        </div>
      )}
      <div className="dark:bg-dark" style={{ minHeight: "100vh" }}>
        <Header enableDarkMode={props.enableDarkMode} />
        <div className="flex justify-between items-center text-gray-600">
          <div className="w-[88%] mx-auto">
            <table className="w-full">
              <thead>
                <tr className="dark:bg-slate-800 dark:text-white bg-background text-gray-800">
                  <th className="py-2 px-4 font-semibold">Customer</th>
                  <th className="py-2 px-4 font-semibold">Email</th>
                  <th className="py-2 px-4 font-semibold">Price</th>
                  <th className="py-2 px-4 font-semibold">Address</th>
                  <th className="py-2 px-4 font-semibold">City</th>
                  <th className="py-2 px-4 font-semibold">Status</th>
                  <th className="py-2 px-4 font-semibold">Mark</th>
                </tr>
              </thead>
              <tbody className="dark:bg-slate-500 dark:text-white">
                {props.bookings.map((booking) => {
                  return (
                    <tr className="text-center" key={booking._id}>
                      <td className="py-2 px-4">{booking.customer}</td>
                      <td className="py-2 px-4">{booking.email}</td>
                      <td className="py-2 px-4">{booking.total}</td>
                      <td className="py-2 px-4">{booking.address}</td>
                      <td className="py-2 px-4">{booking.city}</td>
                      <td>
                        <button className="cursor-default py-1 px-4 bg-green-500 text-white rounded-sm">
                          Hired
                        </button>
                      </td>
                      <td>
                        {booking.status === "Completed" ? (
                          <span className="flex justify-center items-center">
                            <AiFillCheckCircle size="20" />
                          </span>
                        ) : (
                          <button
                            className="py-1 px-4 bg-gray-700 text-white rounded-sm"
                            onClick={() => handleCheck(booking._id)}
                          >
                            Done
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Bookings;
